import React, { PropsWithChildren, useEffect } from 'react'
import { Typography, Box } from '@material-ui/core'
import styled from 'styled-components'
import { CustomTable } from '../eventManagement/CustomTable'
import moment from 'moment'
import { useAdminReportedList } from 'pages/administration/hooks/reported-list/useAdminReportedList'
import { observer } from 'mobx-react'
import { ReportedContentState } from 'models/reported-content/reported-content.store'

const StyledEndText = styled(Typography)`
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: ${props => props.theme.colors.accent1};
  padding-top: 0.938rem;
`
const StyledActivityLogBox = styled(Box)`
  && {
    margin-top: 2rem;
    margin-bottom: 2rem;
    height: 55vh;
    z-index: 0;
    .MuiTableBody-root {
      height: 5vh;
    }
    .MuiTableHead-root {
      position: sticky;
    }
  }
`
const StyledActivityLogHeader = styled(Typography)`
  && {
    font-weight: bold;
    margin-bottom: 1rem;
    font-size: 18px;
  }
`

const ReportActivityLogs = () => {
  const {
    reportActivityLogs,
    reportedContent,
    isReportLogReady,
    reportActivityPage,
    setReportActivityPage
  } = ReportedContentState
  const fetchMoreActivityLogs = () => {
    setReportActivityPage(reportActivityPage + 1)
  }
  const totalCountActivityLogs = parseInt(reportActivityLogs?.totalCount)

  return (
    <StyledActivityLogBox>
      <StyledActivityLogHeader>Activity Logs</StyledActivityLogHeader>
      <CustomTable
        columns={[
          {
            name: 'Date',
            propName: 'createdAt',
            preprocessor(value) {
              return moment(value).format('DD/MM/YYYY')
            }
          },
          {
            name: 'Admin',
            propName: 'admin'
          },
          {
            name: 'Action',
            propName: 'action'
          },
          {
            name: 'Admin Feedback',
            propName: 'adminFeedback'
          }
        ]}
        height={'30vh'}
        data={reportActivityLogs?.data}
        onReachedBottom={() => fetchMoreActivityLogs()}
        showLoader={totalCountActivityLogs > reportActivityLogs?.data.length}
        showNoMoreText={totalCountActivityLogs <= reportActivityLogs?.data.length}
        noMoreText={<StyledEndText>{totalCountActivityLogs === 0 && 'No Activity logs found'}</StyledEndText>}
        isReady={isReportLogReady}
      />
    </StyledActivityLogBox>
  )
}

export default observer(ReportActivityLogs)
